import { render, staticRenderFns } from "./teachers-weeklyplan.vue?vue&type=template&id=fa32367e&"
import script from "./teachers-weeklyplan.vue?vue&type=script&lang=js&"
export * from "./teachers-weeklyplan.vue?vue&type=script&lang=js&"
import style0 from "./teachers-weeklyplan.vue?vue&type=style&index=0&id=fa32367e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports